export const ADDRESS_CONSTRAINTS = {
    name: { maxLength: 100, label: 'Name' },
    addressName: { maxLength: 90, label: 'Address Nickname' },
    address: { maxLength: 256, label: 'Street Address' },
    city: { maxLength: 30, label: 'City' },
    zip: { maxLength: 10, label: 'Zip' },
    typeId: { label: 'Address Type' },
};
//# sourceMappingURL=constraints.js.map